/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_DisplayInputs */

const en_settings_display = /** @type {(inputs: Settings_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display`)
};

/**
* | output |
* | --- |
* | "Display" |
*
* @param {Settings_DisplayInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_display = /** @type {((inputs?: Settings_DisplayInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_DisplayInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_display(inputs)
});